/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import BackgroundToggle from "./common/BackgroundToggle.vue";
import { useSpanglesStore } from "./spangles-module";
import { useDtfStore } from "./store";
import { hasGangSheetError, shouldUseEnhancedMetadata } from "./utils";
import "./ArtworkInfo.scss";

export default function ArtworkInfo({
  artwork = null,
  index = 0,
  showFileInfo = true,
  isMultiUpload = false,
  ...restProps
}) {
  const dtfStore = useDtfStore();
  const spanglesStore = useSpanglesStore();

  // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
  const backgroundTypeModel = dtfStore.backgroundType;

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.showModal;
  }

  function sizeErrorTypes() {
    // @ts-expect-error TS(4111): Property 'sizeErrorTypes' comes from an index sign... Remove this comment to see the full error message
    return dtfStore.sizeErrorTypes;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.isSpangle;
  }

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.showStepsUI;
  }

  function showRedrawUI() {
    // @ts-expect-error TS(4111): Property 'showRedrawUI' comes from an index signat... Remove this comment to see the full error message
    return dtfStore.showRedrawUI;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  // @ts-expect-error TS(6133): 'backgroundType' is declared but its value is neve... Remove this comment to see the full error message
  function backgroundType() {
    // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
    return dtfStore.backgroundType;
  }

  // @ts-expect-error TS(6133): 'experiments' is declared but its value is never r... Remove this comment to see the full error message
  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return dtfStore.experiments;
  }

  function isStandardDTFProduct() {
    // @ts-expect-error TS(4111): Property 'isStandardDTFProduct' comes from an inde... Remove this comment to see the full error message
    return dtfStore.isStandardDTFProduct;
  }

  function allAPIsCompleted() {
    // @ts-expect-error TS(4111): Property 'allAPIsCompleted' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.allAPIsCompleted;
  }

  function metadata() {
    // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
    const { removeBackground, metadata, withBgMetadata } = artwork || {}; // eslint-disable-line no-shadow
    if (!withBgMetadata || Object.keys(withBgMetadata).length === 0) {
      return metadata;
    }
    return removeBackground ? metadata : withBgMetadata;
  }

  function withError() {
    return (
      metadata()?.errors?.length > 0 ||
      // @ts-expect-error TS(2339): Property 'errorMessage' does not exist on type 'ne... Remove this comment to see the full error message
      artwork?.errorMessage ||
      // @ts-expect-error TS(2339): Property 'uploadError' does not exist on type 'nev... Remove this comment to see the full error message
      artwork?.uploadError ||
      // @ts-expect-error TS(2339): Property 'retryFailed' does not exist on type 'nev... Remove this comment to see the full error message
      artwork?.retryFailed
    );
  }

  function hasGangSheetErrorComputed() {
    return hasGangSheetError(artwork);
  }

  function showRemoveButton() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const hasSizeError = sizeErrorTypes().includes(artwork?.errorType?.toString());
    const shouldShowButton = hasSizeError || showModal() || !withError();
    if (isStandardArtwork()) {
      // @ts-expect-error TS(2339): Property 'enhancementCompleted' does not exist on ... Remove this comment to see the full error message
      return shouldShowButton && artwork?.enhancementCompleted;
    }
    if (isSpangle()) {
      return shouldShowButton && allAPIsCompleted();
    }
    return shouldShowButton;
  }

  function svgIcon() {
    const icon = showSteps() ? "empty-image-circle" : "check-bold";
    return withError() ? "cross" : icon;
  }

  function showArtworkInfo() {
    return (
      showModal() ||
      // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message
      ((metadata() || artwork?.isLoading) && !artwork?.uploadError && !artwork?.retryFailed)
    );
  }

  function largeBottomMargin() {
    // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message
    return showSteps() && !artwork?.isLoading;
  }

  function trimmedText() {
    return metadata()?.trimmed ? "Trimmed size" : "Original size";
  }

  function enhancedWidthInch() {
    if (isStandardArtwork()) {
      const useEnhanced = shouldUseEnhancedMetadata(artwork);
      if (!useEnhanced) {
        // @ts-expect-error TS(2339): Property 'originalMetadata' does not exist on type... Remove this comment to see the full error message
        return artwork?.originalMetadata?.widthInch || metadata()?.widthInch;
      }
      // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
      return artwork?.removeBackground
        ? // @ts-expect-error TS(2339): Property 'enhancedMetadata' does not exist on type... Remove this comment to see the full error message
          artwork?.enhancedMetadata?.widthInch || metadata()?.widthInch
        : // @ts-expect-error TS(2339): Property 'withBgMetadata' does not exist on type '... Remove this comment to see the full error message
          artwork?.withBgMetadata?.widthInch || metadata()?.widthInch;
    }
    return metadata()?.widthInch;
  }

  function enhancedHeightInch() {
    if (isStandardArtwork()) {
      const useEnhanced = shouldUseEnhancedMetadata(artwork);
      if (!useEnhanced) {
        // @ts-expect-error TS(2339): Property 'originalMetadata' does not exist on type... Remove this comment to see the full error message
        return artwork?.originalMetadata?.heightInch || metadata()?.heightInch;
      }
      // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
      return artwork?.removeBackground
        ? // @ts-expect-error TS(2339): Property 'enhancedMetadata' does not exist on type... Remove this comment to see the full error message
          artwork?.enhancedMetadata?.heightInch || metadata()?.heightInch
        : // @ts-expect-error TS(2339): Property 'withBgMetadata' does not exist on type '... Remove this comment to see the full error message
          artwork?.withBgMetadata?.heightInch || metadata()?.heightInch;
    }
    return metadata()?.heightInch;
  }

  function enhancedWidthPixel() {
    if (isStandardArtwork()) {
      const useEnhanced = shouldUseEnhancedMetadata(artwork);
      if (!useEnhanced) {
        // @ts-expect-error TS(2339): Property 'originalMetadata' does not exist on type... Remove this comment to see the full error message
        return artwork?.originalMetadata?.width || metadata()?.width;
      }
      // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
      return artwork?.removeBackground
        ? // @ts-expect-error TS(2339): Property 'enhancedMetadata' does not exist on type... Remove this comment to see the full error message
          artwork?.enhancedMetadata?.width || metadata()?.width
        : // @ts-expect-error TS(2339): Property 'withBgMetadata' does not exist on type '... Remove this comment to see the full error message
          artwork?.withBgMetadata?.width || metadata()?.width;
    }
    return metadata()?.width;
  }

  function enhancedHeightPixel() {
    if (isStandardArtwork()) {
      const useEnhanced = shouldUseEnhancedMetadata(artwork);
      if (!useEnhanced) {
        // @ts-expect-error TS(2339): Property 'originalMetadata' does not exist on type... Remove this comment to see the full error message
        return artwork?.originalMetadata?.height || metadata()?.height;
      }
      // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
      return artwork?.removeBackground
        ? // @ts-expect-error TS(2339): Property 'enhancedMetadata' does not exist on type... Remove this comment to see the full error message
          artwork?.enhancedMetadata?.height || metadata()?.height
        : // @ts-expect-error TS(2339): Property 'withBgMetadata' does not exist on type '... Remove this comment to see the full error message
          artwork?.withBgMetadata?.height || metadata()?.height;
    }
    return metadata()?.height;
  }

  function dimensionText() {
    return `${enhancedWidthInch()}" x ${enhancedHeightInch()}"`;
  }

  function pixelDimensionText() {
    return `(${enhancedWidthPixel()}px x ${enhancedHeightPixel()}px)`;
  }

  function showSteps() {
    return showStepsUI() && !isMultiUpload;
  }

  function setRemovalFile(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setRemovalFile(...args);
  }

  function setBackgroundType(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.setBackgroundType(...args);
  }

  function handleBackgroundTypeModelChange(value: any) {
    setBackgroundType(value);
  }

  function onRemove() {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    setRemovalFile(artwork?.id);
  }

  return (
    <>
      {showArtworkInfo() ? (
        <div
          {...restProps}
          // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
          className={cn("artwork-info scope-ab916ad0", restProps?.className, {
            "artwork-info--large-bottom-margin":
              largeBottomMargin() && !(isMultiUpload && showRedrawUI()),
            "artwork-info--standard-artwork": isStandardArtwork(),
            // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message
            "artwork-info--no-margin": artwork?.isLoading
          })}
        >
          {/* @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message */}
          {metadata() && !artwork?.isLoading ? (
            <>
              <div
                className={cn("artwork-info__file-info-row scope-ab916ad0", {
                  "artwork-info__file-info-row--with-error": withError()
                })}
              >
                {showFileInfo ? (
                  <>
                    <UseSvg
                      className={cn("artwork-info__file-info-icon scope-ab916ad0", {
                        "artwork-info__file-info-icon--large": showSteps()
                      })}
                      icon={svgIcon()}
                      data-testid="artwork-info-file-info-icon"
                    />
                    {showSteps() ? (
                      <div className="scope-ab916ad0">
                        {/* @ts-expect-error TS(2339): Property 'name' does not exist on type 'never'. */}
                        {artwork?.name} <br className="scope-ab916ad0" />
                        <b className="scope-ab916ad0">
                          {trimmedText()} {dimensionText()}, {pixelDimensionText()}
                        </b>
                      </div>
                    ) : (
                      <div className="scope-ab916ad0">
                        <b className="scope-ab916ad0">
                          {trimmedText()} {dimensionText()}
                        </b>
                        <br className="scope-ab916ad0" /> {pixelDimensionText()}
                      </div>
                    )}
                  </>
                ) : null}
              </div>
              {!isStandardDTFProduct() ? (
                <div className="artwork-info__actions scope-ab916ad0">
                  {!hasGangSheetErrorComputed() ? (
                    <BackgroundToggle
                      className="scope-ab916ad0"
                      modelValue={backgroundTypeModel}
                      onUpdateModelValue={handleBackgroundTypeModelChange}
                      data-testid="background-toggle"
                    />
                  ) : null}
                  {showRemoveButton() ? (
                    <button
                      className="artwork-info__remove-button scope-ab916ad0"
                      type="button"
                      onClick={onRemove}
                      data-testid="artwork-info-remove-button"
                    >
                      <UseSvg
                        className="artwork-info__trash-icon scope-ab916ad0"
                        icon="trash"
                        data-testid="artwork-info-trash-icon"
                      />{" "}
                      Remove{" "}
                    </button>
                  ) : null}
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
